import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether a media query matches, kept current as the window changes.
 *
 * For choosing *which* markup to render (a timeline or a grid, a wizard or a
 * single form). Hiding one of two copies with CSS would leave both in the DOM,
 * and a test or a screen reader would find every button twice.
 */
export default function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener?.('change', notify);
      return () => list.removeEventListener?.('change', notify);
    },
    [query]
  );

  const snapshot = () =>
    typeof window !== 'undefined' && Boolean(window.matchMedia?.(query).matches);

  return useSyncExternalStore(subscribe, snapshot, () => false);
}

/** Below Bootstrap's `md` breakpoint: the phone layout. */
export const PHONE_QUERY = '(max-width: 767.98px)';

export const useIsPhone = (): boolean => useMediaQuery(PHONE_QUERY);
